import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";

const LINES = [
  "You changed. So should your healthcare.",
  "Because your best years aren't behind you.",
  "Aging isn't the problem. Being ignored is.",
  "Life doesn't slow down. Neither should you.",
];

export const Statement = ({ onBook }) => {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % LINES.length), 3400);
    return () => clearInterval(t);
  }, []);

  return (
    <section
      data-testid="statement-section"
      className="relative bg-char text-[var(--astera-bone)] py-28 lg:py-40 overflow-hidden"
    >
      <div className="pointer-events-none absolute -right-24 top-1/2 -translate-y-1/2 h-[520px] w-[520px] rounded-full bg-clay/15 blur-3xl" />
      <div className="pointer-events-none absolute -left-32 -bottom-24 h-[420px] w-[420px] rounded-full bg-[var(--astera-olive)]/20 blur-3xl" />
      <div className="mx-auto max-w-[1200px] px-6 lg:px-12 relative">
        <p className="mb-8 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[var(--astera-olive-light)]">
          <span className="h-[1px] w-10 bg-[var(--astera-olive-light)]" /> Physician-led. Woman-centred.
        </p>

        <div className="min-h-[3.4em] sm:min-h-[2.6em] lg:min-h-[2.2em]">
          <AnimatePresence mode="wait">
            <motion.h2
              key={i}
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -22 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="font-serif font-light text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-4xl"
            >
              {LINES[i]}
            </motion.h2>
          </AnimatePresence>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row sm:items-center gap-8">
          <button
            onClick={onBook}
            data-testid="statement-book-button"
            className="group inline-flex items-center gap-3 rounded-full bg-clay px-9 py-4 text-sm uppercase tracking-[0.16em] text-[var(--astera-bone)] transition-colors duration-300 hover:bg-[var(--astera-bone)] hover:text-[var(--astera-char)]"
          >
            Take your health personally
            <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
          <p className="text-[var(--astera-bone)]/55 max-w-xs text-sm leading-relaxed">
            Exceptional care for every stage of womanhood — we take your health personally, because you should too.
          </p>
        </div>
      </div>
    </section>
  );
};
